import React from 'react';
import BaseIcon from './BaseIcon';

import { ReactComponent as IconPath } from 'assets/images/icons/pickup-icon.svg';

function PickupIcon(props) {
  return <BaseIcon SVGElement={IconPath} {...props} />;
}

export default PickupIcon;
